import { createContext } from "react";
import { Dictionary } from "../helpers/dictionariesFromLayers";
import { configValidation } from "../helpers/validation/validation";
import { AuthorInstitutionAttributes, AuthorsAttributes, ElaboratorAttributes, InstitutionsAttributes, RastersAttributes } from "./poFormContext";

type SharedProps = {
    id?: number;
    numeR_ROBOCZY?: string;
    datA_WYPELNIENIA?: number;
    globalid?: string;
    osuwiskO_GID?: string;
}

export type landSlideAttributes = TechnicalFields & {
    id: number;
    numeR_IDENTYFIKACYJNY?: number;
    numeR_ROBOCZY?: string | null;
    numerY_DZIALEK?: string | null;
    pL1992_X?: number | null;
    pL1992_Y?: number | null;
    grS80_DLUGOSC?: number | null;
    grS80_SZEROKOSC?: number | null;
    zlewnia?: string | null;
    lokalizacjA_OPIS?: string | null;
    stopieN_AKTYWNOSCI?: string | null;
    charakterystykA_OPIS?: string | null;
    oS_POWIERZCHNIA?: number | null;
    oS_DLUGOSC?: number | null;
    oS_SZEROKOSC?: number | null;
    oS_WYS_MAKS?: number | null;
    oS_WYS_MIN?: number | null;
    oS_ROZPIETOSC?: number | null;
    oS_NACHYLENIE?: number | null;
    oS_AZYMUT?: number | null;
    sG_WYSOKOSC?: number | null;
    sG_NACHYLENIE?: number | null;
    sG_SZCZELINY?: string | null;
    sG_SKARPY_WTORNE?: string | null;
    kO_WYS_CZOLA?: number | null;
    kO_DLUGOSC?: number | null;
    kO_NACHYLENIE?: number | null;
    kO_MIAZSZOSC_POM?: number | null;
    kO_MIAZSZOSC_SZAC?: number | null;
    sT_NACHYLENIE?: number | null;
    sT_DLUGOSC?: number | null;
    sT_WYSOKOSC?: number | null;
    uT_LASY?: number | null;
    uT_ZAROSLA?: number | null;
    uT_LAKI_PASTWISKA?: number | null;
    uT_GRUNTY_ORNE?: number | null;
    uT_SADY?: number | null;
    uT_NIEUZYTKI?: number | null;
    uT_ZAB_MIESZKALNA?: number | null;
    uT_ZAB_GOSPODARCZA?: number | null;
    uT_ZAB_PRZEM_USLUG?: number | null;
    uT_ZAB_UZYT_PUBL?: number | null;
    uT_ZAB_ZABYT_SAKR?: number | null;
    kolej?: number | null;
    liniE_ENERGETYCZNE?: number | null;
    liniE_TELEFONICZNE?: number | null;
    liniE_WODOCIAGI?: number | null;
    liniE_KANALIZACJA?: number | null;
    liniE_GAZOCIAGI?: number | null;
    szkodY_UPRAWY?: string | null;
    zagrozeniA_UPRAWY?: string | null;
    szkodY_ZABUDOWA_OPIS?: string | null;
    szkodY_ZABUDOWA?: string | null;
    zagrozeniA_ZABUDOWA?: string | null;
    szkodY_KOMUNIKACJA?: string | null;
    zagrozeniA_KOMUNIKACJA?: string | null;
    szkodY_LINIE_PRZESYLOWE?: string | null;
    zagrozeniA_LINIE_PRZESYLOWE?: string | null;
    szkodY_INNE?: string | null;
    zagrozeniA_INNE?: string | null;
    czY_ZABEZPIECZONE?: number | null;
    zabezpieczeniA_NAZWA?: string | null;
    zabezpieczeniE_OPIS?: string | null;
    dalszE_RUCHY?: string | null;
    monitorinG_OPIS?: string | null;
    czY_WSKAZANIE_WIZJA?: number | null;
    monitorinG_WSKAZ_WIZJI?: string | null;
    czY_WSKAZANIE_MONITORING?: number | null;
    monitorinG_WSKAZ_MON?: string | null;
    czY_MONITORING_POWIERZCHNIOWY?: number | null;
    monitorinG_POW?: string | null;
    czY_MONITORING_WGLEBNY?: number | null;
    monitorinG_WGL?: string | null;
    uwagi?: string | null;
    datA_USTALENIA?: any | null; // Assuming you want to use Date objects here
    datA_WYPELNIENIA?: any | null; // Assuming you want to use Date objects here
    bibliografia?: string | null;
    wersja?: number | null;
    mapA_KR_SKALA_WYDRUKU?: number | null;
    mapA_A4_SKALA_WYDRUKU?: number | null;
    czY_ZALACZNIK_MONITORINGU?: number | null;
    zmianA_WERSJA?: number | null;
    tyP_STOKU_SID?: number | null;
    tyP_ZABEZPIECZNIA_OSUWISKA_SID?: number | null;
    uklaD_GEOLOGICZNY_SID?: number | null;
    kieruneK_EKSPOZYCJI_SID?: number | null;
    sytuacjA_GEOMORFOLOGICZNA_SID?: number | null;
    rodzaJ_RUCHU_SID?: number | null;
    rodzaJ_MATERIALU_SID?: number | null;
    szkodY_KOMUNIKACJA_OPIS?: string | null;
    regioN_NADRZEDNY?: string | null;
    czY_MONITORING?: number | null;
    monitorinG_STATUS?: number | null;
    globalid?: string;
    miejscowosC_NAZWA?: string | null;
    liniE_INNE?: number | null;
    uT_ZAB_INNA?: string | null;
    arcH_ID?: number;
    miejscowosC_GID?: string | null;
    shape__Area?: number | null;
    shape__Length?: number | null;
}

export type endangeredAreaAttributes = TechnicalFields & {
    id: number;
    numeR_IDENTYFIKACYJNY?: number;
    numeR_ROBOCZY?: string | null;
    numerY_DZIALEK?: string | null;
    pL1992_X?: number | null;
    pL1992_Y?: number | null;
    grS80_DLUGOSC?: number | null;
    grS80_SZEROKOSC?: number | null;
    wskazania?: string | null;
    datA_USTALENIA?: any | null; // Assuming you want to use Date objects here
    datA_WYPELNIENIA?: any | null; // Assuming you want to use Date objects here
    wersjA_KARTY?: number | null;
    zmianA_WERSJA?: number | null;
    mapA_KR_SKALA_WYDRUKU?: number | null;
    globalid: string;
    miejscowosC_NAZWA?: string | null;
    arcH_ID?: number;
    miejscowosC_GID?: string | null;
    shape__Area?: number | null;
    shape__Length?: number | null;
}

export type EndangeredAreaGminyAttributes = GminyAttributes & {
    tereN_ZAGROZONY_GID: string;
};

export type LandslideGminyAttributes = GminyAttributes & {
    osuwiskO_GID: string;
};

type GminyAttributes = TechnicalFields & {
    id: number;
    powierzchnia?: number | null;
    kolejnosc?: number | null;
    teryt?: string | null;
    globalid: string;
    wojewodztwo?: string | null;
    powiat?: string | null;
    gmina?: string | null;
    gminA_ID?: number
}

export type krFormTypes = KrLandslideFormTypes | KrEndangeredAreaFormTypes

export type KrEndangeredAreaFormTypes = KrSharedFormTypes & {
    endangeredAreaAttributes?: endangeredAreaAttributes;
    endangeredAreaGminy?: EndangeredAreaGminyAttributes[];
    endangeredAreaRasters?: EndangeredAreaRasters[];
    designationCriteria?: EndangeredAreaDesignationCriteria[];
    dicts?: RegistrationCardEndangeredAreaDicts;
}

export type KrLandslideFormTypes = KrSharedFormTypes & {
    landslideAttributes?: landSlideAttributes;
    landslideGminy?: LandslideGminyAttributes[];
    geographicalLands?: LandslideGeographicalLands[];
    secondarySlopes?: LandslideSecondarySlopes[];
    foreheads?: LandslideForeheads[];
    rubbles?: LandslideRubbles[];
    rocks?: LandslideRocks[];
    sheets?: Landslide10kSheets[];
    recesses?: LandslideRecesses[];
    surfaceWaters?: LandslideSurfaceWaters[];
    documents?: LandSlideDocuments[];
    roadCategories?: LandslideRoadCategories[];
    koluvia?: LandslideKoluvia[];
    trenches?: LandslideTrenches[];
    sMGP50Ks?: LandslideSMGP50k[];
    slots?: LandslideSlots[];
    activityZones?: LandslideActivityZones[];
    tectonics?: LandslideTectonics[];
    boundaries?: LandslideBoundaries[];
    tectonicUnits?: LandslideTectonicUnits[];
    accumulationThresholds?: LandslideAccumulationThresholds[];
    developments?: LandslideDevelopment[];
    waterPoints?: LandslideWaterPoints[];
    mainSlopes?: LandslideMainSlopes[];
    rockDeposits?: LandslideRockDeposits[];
    rocksDepositAzimuths?: LandslideRocksDepositAzimuths[];
    publications?: LandslidePublications[];
    waters?: LandslideWaters[];
    movementCause?: LandslideMovementCause[];
    landslideRasters?: LandslideRasters[];
    landslideBuildingDamages?: LandslideBuildingDamage[];
    landslideRoadDamages?: LandslideRoadDamages[];
    landslideMonitoringRegisters?: MonitoringRegisters[];
    landslideMonitoringAttachments?: MonitoringAttachments[];
    dicts?: RegistrationCardDicts
}

export type KrSharedFormTypes = {
    dictionaries?: Dictionary;
    config?: ConfigField;
    waitingRoomGlobalId?: string;
    waitingRoomId?: number;
    elaborators?: ElaboratorAttributes[];
    formComments?: FormComment[];
    dictionariesCodedValues?: Dictionary;
}

export type FormComment = {
    id?: number,
    poczekalniA_ID?: number,
    atrybuT_KOMENTOWANY?: string,
    datA_KOMENTARZA?: any,              // Datetime
    tresc?: string,
    autor?: string,
    czY_POPRAWIONE?: number,            // Boolean
    komentarZ_GID?: string | null,
    globalid?: string
    comments?: FormComment[],

    // Local attributes
    localUUID?: string,
    sectionHeading?: string
}

export type RegistrationCardEndangeredAreaDicts = RegistrationCardDicts & {
    detailedDesignationCriteriaDict?: DetailedDesignationCriteriaDict[]
    dicts?: RegistrationCardDicts;
}

export type MonitoringRegisters = SharedProps & {
    rodzaJ_MONITORINGU_SID?: number,
    datA_OD?: any,
    datA_DO?: any,
    datA_OD_VIEW?: string,
    datA_DO_VIEW?: string,
    wykonawca?: string,
    opis?: string,
    osuwiskO_NR_IDENTYFIKACYJNY?: number,
    miejscowosC_NAZWA?: string | null,
    idx?: number

    // Local attributes
    localUUID?: string
}

export type RegistrationCardDicts = {
    authorsDict?: AuthorsAttributes[],
    institutionsDict?: InstitutionsAttributes[],
    authorInstitutionsDict?: AuthorInstitutionAttributes[],
    detailedDesignationCriteriaDict?: DetailedDesignationCriteriaDict[],
    zlewniaDict?: Zlewnia[],
    krainyDict?: KrainyGeograficzne[]
}

export type Zlewnia = {
    nazwa?: string,
    poziom?: string
}

export type KrainyGeograficzne = {
    nazwa?: string,
    powierzchnia?: number
}

export type DetailedDesignationCriteriaDict = {
    id?: number,
    kryT_WYZN_TZ_GLOWNE_ID?: number,
    wartosc?: string,
    wartosC_EN?: string,
    waznY_OD?: number,
    waznY_DO?: number,
    kolejnosc?: number,
    poprzednik?: number
}

export type LandslideRoadDamages = SharedProps & {
    infrastrukturA_KOM_SID?: number;
    dlugosc?: number;
    idx?: number;
}

export type MonitoringAttachments = SharedProps & {
    monitorinG_REJESTR_ID?: number,
    monitorinG_REJESTR_GID?: string,
    rodzaJ_ZALACZNIKA_MONIT_SID?: number,
    pliK_SCIEZKA?: string,
    rok?: number,
    details?: RastersAttributes

    // Local attributes
    nameRodzaj?: string,
    monitoringLocalUUID?: string,
    pliK_NAZWA?: string
}

export type LandslideRasters = SharedProps & {
    rasteR_GID?: string,
    details?: RastersAttributes
}

export type EndangeredAreaRasters = SharedProps & {
    tereN_ZAGROZONY_GID?: string,
    rasteR_GID?: string,
    details?: RastersAttributes
}

export type LandslideResearch = {
    category?: string | null,
    year?: number | null,
    authors?: string | null,
    title?: string | null,
    itemGlobalId?: string | null
}

export enum ResearchCategories {
    Document = "Dokument",
    Publication = "Publikacja"
}

export type LandslidePublications = SharedProps & {
    osuwiskA_GID?: string,
    publikacE_SOPO_GID?: string,
    details?: PublicationsAttributes,
    rid?: number
}

export type PublicationsAttributes = SharedProps & {
    autorzy?: string | null,
    publikacjA_SOPO?: string | null,
    czasopismO_NAZWA?: string | null,
    czasopismO_OZNACZENIE?: string | null,
    wydawnictwO_NAZWA?: string | null,
    roK_POWSTANIA?: number | null,
    tyP_PUBLIKACJI_SID?: number | null,

    // Additional attributes for dict proposals
    slownikI_PROPOZYCJE_ID?: number
}

export type ConfigField = {
    check?: boolean;
    Validation?: Record<string, configValidation>;
    ValidationWarnings?: Record<string, configValidation>;
    LabelNames?: Record<string, string>;
    ValidationError?: Record<string, string>;
    ValidationWarningsError?: Record<string, string>;
    isValid?: boolean;
    isValidWarnings?: boolean;
}

export type LandslideRockDeposits = SharedProps & {
    rodzaJ_ZALEGANIA_SKALY_SID?: number;
    kolejnosc?: number;
    osuwiskO_SKALA_GID?: string;
    idx?: number;
};

export type LandslideRocksDepositAzimuths = SharedProps & {
    kolejnosc?: number;
    zaleganiE_SKALY_OSUWISKA_GID?: string;
    azymut?: number;
    upad?: number;
    idx?: number;
};

export type LandslideGeographicalLands = SharedProps & {
    powierzchnia?: number;
    nazwa?: string;
    kolejnosc?: number;
};

export type LandslideSecondarySlopes = SharedProps & {
    staN_DOM?: string;
    wysokosC_FORMY_DOM?: string;
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
    numeR_IDENTYFIKACYJNY?: number;
};

export type LandslideForeheads = SharedProps & {
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
    wysokosC_FORMY?: number;
};

export type LandslideRubbles = SharedProps & {
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
};

export type LandslideRocks = SharedProps & {
    skalY_RODZAJ_SID?: number;
    kolejnosc?: number;
    stratygrafiA_OD_SID?: number;
    stratygrafiA_DO_SID?: number;
};

export type Landslide10kSheets = SharedProps & {
    kolejnosc?: number;
    godlo?: string;
};

export type LandslideRecesses = SharedProps & {
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
};

export type LandslideSurfaceWaters = SharedProps & {
    tyP_WODY_POW_DOM?: string;
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
};

export type LandSlideDocuments = SharedProps & {
    autorzy?: string;
    nR_INWENTARZOWY?: string;
    tytul?: string;
    uwagi?: string;
    rok?: number;
    wykonawca?: string;
    opraC_ID?: number;
    nazwA_FIRMY?: string;
    adreS_FIRMY?: string;
    nazwA_ARCHIWUM?: string;
    adreS_ARCHIWUM?: string;
    source?: string
};

export type DocumentsAttributes = SharedProps & {
    autorzy?: string | null,
    numerY_INW?: string | null,
    mapA50?: string | null,
    mapA10?: string | null,
    tytul?: string | null,
    uwagi?: string | null,
    rok?: number | null,
    nazwA_FIRMY?: string | null,
    adreS_FIRMY?: string | null,
    nazwA_ARCHIWUM?: string | null,
    adreS_ARCHIWUM?: string | null,

    // Additional attributes for dict proposals
    slownikI_PROPOZYCJE_ID?: number
}

export type LandslideRoadCategories = SharedProps & {
    kategoriA_DROGI_SID?: number;
};

export type LandslideKoluvia = SharedProps & {
    rodzaJ_KOLUWIUM_SID?: number;
    kolejnosc?: number;
};

export type LandslideTrenches = SharedProps & {
    wysokosC_FORMY_DOM?: string;
    staN_DOM?: string;
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
    numeR_IDENTYFIKACYJNY?: number;
};

export type LandslideSMGP50k = SharedProps & {
    godlo?: string;
    nazwa?: string;
    kolejnosc?: number;
};

export type LandslideSlots = SharedProps & {
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
};

export type LandslideActivityZones = SharedProps & {
    tyP_AKTYWNOSCI_DOM?: string;
    powierzchnia?: number;
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
};

export type LandslideTectonics = SharedProps & {
    rodzaJ_TEKTONIKI_SID?: number;
    kolejnosc?: number;
};

export type LandslideBoundaries = SharedProps & {
    graN_OSUW_DOM?: string;
    rozpoznaniE_DOM?: string;
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
};

export type LandslideTectonicUnits = SharedProps & {
    opis?: string;
    kolejnosc?: number;
    jednostkA_TEKTONICZNA_GID?: string;
};

export type LandslideAccumulationThresholds = SharedProps & {
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
};

export type LandslideDevelopment = SharedProps & {
    tyP_ZDARZENIA_SID?: number;
    porA_ROKU_SID?: number;
    porA_ROKU_DO_SID?: number;
    rodzaJ_OKRESU_CZASU_SID?: number;
    przeD_PO_SID?: number;
    datA_DZIEN?: number;
    datA_DZIEN_DO?: number;
    datA_MIESIAC?: number;
    datA_MIESIAC_DO?: number;
    datA_ROK?: number;
    datA_ROK_DO?: number;
    datA_UWAGI?: string;
    genezA_OPIS?: string;
    wiek?: string;
    wieK_DO?: string;
    epoka?: string;
    czY_ZAKRES_DAT?: number;
    datA_PREZENTACJA?: number;
    kolejnosc?: number;

    // Local attributes
    localUUID?: string,
    pointInTime?: number
};

export type LandslideWaterPoints = SharedProps & {
    tyP_WODY_PKT_DOM?: string;
    kat?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
};

export type LandslideMainSlopes = SharedProps & {
    formA_LIN_DOM?: string;
    staN_DOM?: string;
    wysokosC_FORMY_DOM?: string;
    zmianA_WERSJA?: number;
    osuwiskO_NUMER_IDENTYFIKACYJNY?: number;
    numeR_IDENTYFIKACYJNY?: number;
};

export type LandslideMovementCause = SharedProps & {
    osuwiskO_ROZWOJ_GID?: string;
    przyczynA_RUCHU_SID?: number;
    idx?: number;

    // Local attributes
    devId?: string
}

export type LandslideWaters = SharedProps & {
    tyP_STREFY_SID?: number;
    tyP_PRZEJAWU_SID?: number;
    czY_ANALIZA?: number;
}

export type LandslideBuildingDamage = SharedProps & {
    rodzaJ_ZABUDOWY_SID?: number;
    rodzaJ_SZKODY_SID?: number;
    liczba?: number;
    //TODO: need to change this for second record becouse of model
    liczba2?: number;
    idx?: number;
}

export type EndangeredAreaDesignationCriteria = TechnicalFields & {
    id?: number;
    kryT_WYZN_TZ_GLOWNE_ID: number | null;
    kryT_WYZN_TZ_SZCZEGOLOWE_ID: number | null;
    uzasadnienie: string | null;
    globalid?: string;
    tereN_ZAGROZONY_GID?: string;
};

type TechnicalFields = {
    createD_USER?: string;
    createD_DATE?: string;
    lasT_EDITED_USER?: string;
    lasT_EDITED_DATE?: string;
}

export type MonitoringAttributes = SharedProps & {

}

export const defaultKrForm = () => {
    var krForm: krFormTypes = {

    };
    return krForm;
}

export const labelKrPO = () => {
    var labelNames: Record<string, string> = {};
    labelNames["obiekT_NUMER_IDENTYFIKACYJNY"] = "Numer ewidencyjny protokołu obserwacji";
    labelNames["wnioski"] = "Wnioski z obserwacji";
    labelNames["zalecenia"] = "Zalecenia co do dalszych obserwacji";
    labelNames["rasters"] = "zdjęcia";
    labelNames["elaborators"] = "Wypełniający";
    labelNames["datA_OBS"] = "Data obserwacji";
    labelNames["datA_PROT"] = "Data sporządzenia protokołu obserwacji";
    return labelNames;
}

export const sortedKrPO = () => {
    return ["obiekT_NUMER_IDENTYFIKACYJNY", "wnioski", "zalecenia", "rasters", "elaborators", "datA_OBS", "datA_PROT"]
}

export const HeadlineNamesKRPO = () => {
    var headlineNames: Record<string, string[]> = {};
    headlineNames["Numer ewidencyjny"] = ["obiekT_NUMER_IDENTYFIKACYJNY"];
    headlineNames["Wnioski z obserwacji"] = ["wnioski"];
    headlineNames["Zalecenia co do dalszych obserwacji"] = ["zalecenia"];
    headlineNames["Dokumentacja fotograficzna"] = ["rasters"];
    headlineNames["Sporządzający protokół obserwacji"] = ["elaborators"];
    headlineNames["Data obserwacji"] = ["datA_OBS"];
    headlineNames["Data sporządzenia protokołu obserwacji"] = ["datA_PROT"];
    return headlineNames;
}

export const labelKrForm2020 = () => {
    var labelNames: Record<string, string> = {};
    labelNames["numeR_IDENTYFIKACYJNY"] = "Numer ewidencyjny";
    labelNames["numeR_ROBOCZY"] = "Numer roboczy";
    labelNames["miejscowosC_NAZWA"] = "Miejscowość";
    labelNames["gmina"] = "Gmina";
    labelNames["powiat"] = "Powiat";
    labelNames["wojewodztwo"] = "Województwo";
    labelNames["numerY_DZIALEK"] = "Numery ewidencyjne działek";
    labelNames["godlo10k"] = "Mapa topograficzna 1:10 000";
    labelNames["smgp50k"] = "Arkusz SMGP 1:50 000";
    labelNames["pL1992_X"] = "x";
    labelNames["pL1992_Y"] = "y";
    labelNames["grS80_DLUGOSC"] = "Długość geograficzna";
    labelNames["grS80_SZEROKOSC"] = "Szerokość geograficzna";
    labelNames["geographicalLands"] = "Kraina geograficzna";
    labelNames["tectonicUnits"] = "Jednostka tektoniczna";
    labelNames["zlewnia"] = "Zlewnia";
    labelNames["lokalizacjA_OPIS"] = "Inne dane lokalizacyjne";
    labelNames["stopieN_AKTYWNOSCI"] = "Stopień aktywności";
    labelNames["charakterystykA_OPIS"] = "Krótki opis";
    labelNames["oS_POWIERZCHNIA"] = "Powierzchnia [ha]";
    labelNames["oS_DLUGOSC"] = "Długość osuwiska";
    labelNames["oS_SZEROKOSC"] = "Szerokość";
    labelNames["oS_WYS_MAKS"] = "Wysokość maksymalna";
    labelNames["oS_WYS_MIN"] = "Wysokość minimalna";
    labelNames["oS_ROZPIETOSC"] = "Rozpiętość pionowa";
    labelNames["oS_NACHYLENIE"] = "Nachylenie osuwiska";
    labelNames["oS_AZYMUT"] = "Azymut";
    labelNames["sG_WYSOKOSC"] = "Wysokość skarpy głównej";
    labelNames["sG_NACHYLENIE"] = "Nachylenie skarpy głównej";
    labelNames["sG_SZCZELINY"] = "Szczeliny powyżej skarpy";
    labelNames["sG_SKARPY_WTORNE"] = "Skarpy drugorzędne";
    labelNames["kO_WYS_CZOLA"] = "Wysokość czoła";
    labelNames["kO_DLUGOSC"] = "Długość koluwium";
    labelNames["kO_NACHYLENIE"] = "Nachylenie koluwium";
    labelNames["kO_MIAZSZOSC_POM"] = "Miąższość mierzona";
    labelNames["kO_MIAZSZOSC_SZAC"] = "Miąższość szacowana";
    labelNames["sT_NACHYLENIE"] = "Nachylenie stoku";
    labelNames["sT_DLUGOSC"] = "Długość stoku";
    labelNames["sT_WYSOKOSC"] = "Wysokość stoku";
    labelNames["uT_LASY"] = "Lasy";
    labelNames["uT_ZAROSLA"] = "Zarośla krzewiaste";
    labelNames["uT_LAKI_PASTWISKA"] = "Łąki i pastwiska";
    labelNames["uT_GRUNTY_ORNE"] = "Grunty orne";
    labelNames["uT_SADY"] = "Sady";
    labelNames["uT_NIEUZYTKI"] = "Nieużytki";
    labelNames["uT_ZAB_MIESZKALNA"] = "Mieszkalna";
    labelNames["uT_ZAB_GOSPODARCZA"] = "Gospodarcza";
    labelNames["uT_ZAB_PRZEM_USLUG"] = "Przemysłowa/usługowa";
    labelNames["uT_ZAB_UZYT_PUBL"] = "Użyteczności publicznej";
    labelNames["uT_ZAB_ZABYT_SAKR"] = "Zabytkowa/sakralna";
    labelNames["uT_ZAB_INNA"] = "Inna";
    labelNames["kolej"] = "Linie kolejowe";
    labelNames["liniE_ENERGETYCZNE"] = "Linie energetyczne";
    labelNames["liniE_TELEFONICZNE"] = "Linie telefoniczne";
    labelNames["liniE_WODOCIAGI"] = "Wodociągi";
    labelNames["liniE_KANALIZACJA"] = "Kanalizacja";
    labelNames["liniE_GAZOCIAGI"] = "Gazociągi";
    labelNames["szkodY_UPRAWY"] = "Uprawy - szkody";
    labelNames["zagrozeniA_UPRAWY"] = "Uprawy - zagrożenia";
    labelNames["szkodY_ZABUDOWA_OPIS"] = "Zabudowa - szkody";
    labelNames["zagrozeniA_ZABUDOWA"] = "Zabudowa - zagrożenia";
    labelNames["zagrozeniA_KOMUNIKACJA"] = "Infrastruktura komunikacyjna - zagrożenia";
    labelNames["szkodY_LINIE_PRZESYLOWE"] = "Linie przesyłowe - szkody";
    labelNames["zagrozeniA_LINIE_PRZESYLOWE"] = "Linie przesyłowe - zagrożenia";
    labelNames["szkodY_INNE"] = "Inne - szkody";
    labelNames["zagrozeniA_INNE"] = "Inne - zagrożenia";
    labelNames["czY_ZABEZPIECZONE"] = "";
    labelNames["zabezpieczeniA_NAZWA"] = "";
    labelNames["zabezpieczeniE_OPIS"] = "Rodzaje i zakres wykonywanych prac zabezpieczających";
    labelNames["dalszE_RUCHY"] = "Ocena możliwości wystąpienia dalszych ruchów osuwiskowych";
    labelNames["monitorinG_OPIS"] = "";
    labelNames["czY_WSKAZANIE_WIZJA"] = "";
    labelNames["monitorinG_WSKAZ_WIZJI"] = "Wskazania do prowadzenia wizji w terenie";
    labelNames["czY_WSKAZANIE_MONITORING"] = "";
    labelNames["monitorinG_WSKAZ_MON"] = "Wskazania do wprowadzenia monitoringu";
    labelNames["czY_MONITORING_POWIERZCHNIOWY"] = "Czy prowadzono monitoring powierzchniowy?";
    labelNames["monitorinG_POW"] = "";
    labelNames["czY_MONITORING_WGLEBNY"] = "Czy prowadzono monitoring wgłębny?";
    labelNames["monitorinG_WGL"] = "";
    labelNames["uwagi"] = "Uwagi";
    labelNames["datA_USTALENIA"] = "Data ustalenia";
    labelNames["datA_WYPELNIENIA"] = "Data wypełnienia";
    labelNames["bibliografia"] = "Bibliografia";
    labelNames["wersja"] = "";
    labelNames["mapA_KR_SKALA_WYDRUKU"] = "";
    labelNames["mapA_A4_SKALA_WYDRUKU"] = "";
    labelNames["czY_ZALACZNIK_MONITORINGU"] = "";
    labelNames["zmianA_WERSJA"] = "";
    //labelNames["tyP_STOKU_SID"] = "Typ stoku";
    labelNames["tyP_ZABEZPIECZNIA_OSUWISKA_SID"] = "";
    labelNames["uklaD_GEOLOGICZNY_SID"] = "Układ geologiczny";
    labelNames["kieruneK_EKSPOZYCJI_SID"] = "Ekspozycja";
    labelNames["sytuacjA_GEOMORFOLOGICZNA_SID"] = "Sytuacja geomorfologiczna";
    labelNames["rodzaJ_RUCHU_SID"] = "Rodzaj ruchu";
    labelNames["rodzaJ_MATERIALU_SID"] = "Rodzaj materiału";
    labelNames["szkodY_KOMUNIKACJA_OPIS"] = "Infrastruktura komunikacyjna - szkody";
    labelNames["regioN_NADRZEDNY"] = "";
    labelNames["czY_MONITORING"] = "";
    labelNames["monitorinG_STATUS"] = "";
    labelNames["liniE_INNE"] = "Inne";
    labelNames["tectonics"] = "Tektonika";
    labelNames["rocks"] = "Wydzielenie";
    labelNames["koluvia"] = "Rodzaj koluwiuw";
    labelNames["waterManifestation1"] = "Koluwium";
    labelNames["waterManifestation2"] = "Skarpy głównej i stoku powyżej skarpy";
    labelNames["waterManifestation3"] = "Stoku poniżej osuwiska";
    labelNames["waterManifestation4"] = "Stoku po bokach osuwiska";
    labelNames["developments"] = "Zdarzenia";
    labelNames["landUse"] = "Pokrycie stoku";
    labelNames["roads"] = "Drogi";
    labelNames["landslideMonitoringRegisters"] = "Monitoring";
    labelNames["publications"] = "Dokumenty i publikacje";
    labelNames["rastersElements1"] = "Mapa";
    labelNames["rastersElements2"] = "Przekrój geologiczny osuwiska";
    labelNames["rastersElements3"] = "Dokumentacja fotograficzna";
    labelNames["elaborators"] = "Wypełniający";
    labelNames["sMGP50Ks"] = "Arkusz SMGP 1:50 000";
    labelNames["sheets"] = "Mapa topograficzna 1:10 000";
    labelNames["wskazania"] = "Wskazania dotyczące obserwacji";
    labelNames["designationCriteria"] = "Główne kryteria wyznaczenia terenu";
    labelNames["roadDamages"] = "Uszkodzenia infrastruktury komunikacyjnej";
    return labelNames;
}

export const labelKrForm2007 = () => {
    var labelNames: Record<string, string> = {};
    labelNames["sG_SKARPY_WTORNE"] = "Skarpy wtórne";
    labelNames["sheets"] = "Mapa topograficzna";
    labelNames["numeR_IDENTYFIKACYJNY"] = "Numer ewidencyjny";
    labelNames["numeR_ROBOCZY"] = "Numer roboczy";
    labelNames["miejscowosC_NAZWA"] = "Miejscowość";
    labelNames["gmina"] = "Gmina";
    labelNames["powiat"] = "Powiat";
    labelNames["wojewodztwo"] = "Województwo";
    labelNames["numerY_DZIALEK"] = "Numery ewidencyjne działek";
    labelNames["godlo10k"] = "Mapa topograficzna 1:10 000";
    labelNames["smgp50k"] = "Arkusz SMGP 1:50 000";
    labelNames["pL1992_X"] = "x";
    labelNames["pL1992_Y"] = "y";
    labelNames["grS80_DLUGOSC"] = "Długość geograficzna";
    labelNames["grS80_SZEROKOSC"] = "Szerokość geograficzna";
    labelNames["geographicalLands"] = "Kraina geograficzna";
    labelNames["tectonicUnits"] = "Jednostka tektoniczna";
    labelNames["zlewnia"] = "Zlewnia";
    labelNames["lokalizacjA_OPIS"] = "Inne dane lokalizacyjne";
    labelNames["stopieN_AKTYWNOSCI"] = "Stopień aktywności";
    labelNames["charakterystykA_OPIS"] = "Krótki opis";
    labelNames["oS_POWIERZCHNIA"] = "Powierzchnia [ha]";
    labelNames["oS_DLUGOSC"] = "Długość osuwiska";
    labelNames["oS_SZEROKOSC"] = "Szerokość";
    labelNames["oS_WYS_MAKS"] = "Wysokość maksymalna";
    labelNames["oS_WYS_MIN"] = "Wysokość minimalna";
    labelNames["oS_ROZPIETOSC"] = "Rozpiętość pionowa";
    labelNames["oS_NACHYLENIE"] = "Nachylenie osuwiska";
    labelNames["oS_AZYMUT"] = "Azymut";
    labelNames["sG_WYSOKOSC"] = "Wysokość skarpy głównej";
    labelNames["sG_NACHYLENIE"] = "Nachylenie skarpy głównej";
    labelNames["sG_SZCZELINY"] = "Szczeliny powyżej skarpy";
    labelNames["kO_WYS_CZOLA"] = "Wysokość czoła";
    labelNames["kO_DLUGOSC"] = "Długość koluwium";
    labelNames["kO_NACHYLENIE"] = "Nachylenie koluwium";
    labelNames["kO_MIAZSZOSC_POM"] = "Miąższość mierzona";
    labelNames["kO_MIAZSZOSC_SZAC"] = "Miąższość szacowana";
    labelNames["sT_NACHYLENIE"] = "Nachylenie stoku";
    labelNames["sT_DLUGOSC"] = "Długość stoku";
    labelNames["sT_WYSOKOSC"] = "Wysokość stoku";
    labelNames["uT_LASY"] = "Lasy";
    labelNames["uT_ZAROSLA"] = "Zarośla krzewiaste";
    labelNames["uT_LAKI_PASTWISKA"] = "Łąki i pastwiska";
    labelNames["uT_GRUNTY_ORNE"] = "Grunty orne";
    labelNames["uT_SADY"] = "Sady";
    labelNames["uT_NIEUZYTKI"] = "Nieużytki";
    labelNames["uT_ZAB_MIESZKALNA"] = "Mieszkalna";
    labelNames["uT_ZAB_GOSPODARCZA"] = "Gospodarcza";
    labelNames["uT_ZAB_PRZEM_USLUG"] = "Przemysłowa/usługowa";
    labelNames["uT_ZAB_UZYT_PUBL"] = "Użyteczności publicznej";
    labelNames["uT_ZAB_ZABYT_SAKR"] = "Zabytkowa/sakralna";
    labelNames["uT_ZAB_INNA"] = "Inna";
    labelNames["kolej"] = "Linie kolejowe";
    labelNames["liniE_ENERGETYCZNE"] = "Linie energetyczne";
    labelNames["liniE_TELEFONICZNE"] = "Linie telefoniczne";
    labelNames["liniE_WODOCIAGI"] = "Wodociągi";
    labelNames["liniE_KANALIZACJA"] = "Kanalizacja";
    labelNames["liniE_GAZOCIAGI"] = "Gazociągi";
    labelNames["szkodY_UPRAWY"] = "Uprawy";
    labelNames["zagrozeniA_UPRAWY"] = "Uprawy";
    labelNames["szkodY_ZABUDOWA_OPIS"] = "Zabudowa";
    labelNames["zagrozeniA_ZABUDOWA"] = "Zabudowa";
    labelNames["zagrozeniA_KOMUNIKACJA"] = "Infrastruktura komunikacyjna";
    labelNames["szkodY_LINIE_PRZESYLOWE"] = "Linie przesyłowe";
    labelNames["zagrozeniA_LINIE_PRZESYLOWE"] = "Linie przesyłowe";
    labelNames["szkodY_INNE"] = "Inne";
    labelNames["zagrozeniA_INNE"] = "Inne";
    labelNames["czY_ZABEZPIECZONE"] = "";
    labelNames["zabezpieczeniA_NAZWA"] = "";
    labelNames["zabezpieczeniE_OPIS"] = "Rodzaje i zakres wykonywanych prac zabezpieczających";
    labelNames["dalszE_RUCHY"] = "Ocena możliwości wystąpienia dalszych ruchów osuwiskowych";
    labelNames["monitorinG_OPIS"] = "";
    labelNames["czY_WSKAZANIE_WIZJA"] = "";
    labelNames["monitorinG_WSKAZ_WIZJI"] = "Wskazania do prowadzenia wizji w terenie";
    labelNames["czY_WSKAZANIE_MONITORING"] = "";
    labelNames["monitorinG_WSKAZ_MON"] = "Wskazania do wprowadzenia monitoringu";
    labelNames["czY_MONITORING_POWIERZCHNIOWY"] = "";
    labelNames["monitorinG_POW"] = "";
    labelNames["czY_MONITORING_WGLEBNY"] = "";
    labelNames["monitorinG_WGL"] = "";
    labelNames["uwagi"] = "Uwagi";
    labelNames["datA_USTALENIA"] = "Data ustalenia";
    labelNames["datA_WYPELNIENIA"] = "Data wypełnienia";
    labelNames["bibliografia"] = "Bibliografia";
    labelNames["wersja"] = "";
    labelNames["mapA_KR_SKALA_WYDRUKU"] = "";
    labelNames["mapA_A4_SKALA_WYDRUKU"] = "";
    labelNames["czY_ZALACZNIK_MONITORINGU"] = "";
    labelNames["zmianA_WERSJA"] = "";
    labelNames["tyP_STOKU_SID"] = "Typ stoku";
    labelNames["tyP_ZABEZPIECZNIA_OSUWISKA_SID"] = "";
    labelNames["uklaD_GEOLOGICZNY_SID"] = "Układ geologiczny";
    labelNames["kieruneK_EKSPOZYCJI_SID"] = "Ekspozycja";
    labelNames["sytuacjA_GEOMORFOLOGICZNA_SID"] = "Sytuacja geomorfologiczna";
    labelNames["rodzaJ_RUCHU_SID"] = "Rodzaj ruchu";
    labelNames["rodzaJ_MATERIALU_SID"] = "Rodzaj materiału";
    labelNames["szkodY_KOMUNIKACJA_OPIS"] = "Infrastruktura komunikacyjna";
    labelNames["regioN_NADRZEDNY"] = "";
    labelNames["czY_MONITORING"] = "Czy prowadzono monitoring?";
    labelNames["monitorinG_STATUS"] = "";
    labelNames["liniE_INNE"] = "Inne";
    labelNames["tectonics"] = "Tektonika";
    labelNames["rocks"] = "Wydzielenie";
    labelNames["koluvia"] = "Rodzaj koluwiuw";
    labelNames["waterManifestation1"] = "Koluwium";
    labelNames["waterManifestation2"] = "Skarpy głównej i stoku powyżej skarpy";
    labelNames["waterManifestation3"] = "Stoku poniżej osuwiska";
    labelNames["waterManifestation4"] = "Stoku po bokach osuwiska";
    labelNames["developments"] = "Zdarzenia";
    labelNames["landUse"] = "Pokrycie stoku";
    labelNames["roads"] = "Drogi";
    labelNames["landslideMonitoringRegisters"] = "Monitoring";
    labelNames["publications"] = "Dokumenty i publikacje";
    labelNames["rastersElements1"] = "Mapa";
    labelNames["rastersElements2"] = "Przekrój geologiczny osuwiska";
    labelNames["rastersElements3"] = "Dokumentacja fotograficzna";
    labelNames["elaborators"] = "Wypełniający";
    labelNames["sMGP50Ks"] = "Arkusz SMGP 1:50 000";
    labelNames["wskazania"] = "Wskazania dotyczące obserwacji";
    labelNames["designationCriteria"] = "Główne kryteria wyznaczenia terenu";
    labelNames["roadDamages"] = "Uszkodzenia infrastruktury komunikacyjnej";
    return labelNames;
}

export const SortedArrayKROAttributes = () =>{
    return ["numeR_IDENTYFIKACYJNY", "numeR_ROBOCZY", "miejscowosC_NAZWA", "gmina", "powiat", "wojewodztwo", 
    "numerY_DZIALEK", "sheets", "sMGP50Ks", "pL1992_X", "pL1992_Y",
    "grS80_DLUGOSC", "grS80_SZEROKOSC", "geographicalLands", "tectonicUnits", "zlewnia", "lokalizacjA_OPIS", 
    "sytuacjA_GEOMORFOLOGICZNA_SID", "uklaD_GEOLOGICZNY_SID", "rodzaJ_MATERIALU_SID", "rodzaJ_RUCHU_SID", "stopieN_AKTYWNOSCI",
    "charakterystykA_OPIS", "oS_POWIERZCHNIA", "oS_DLUGOSC", "oS_SZEROKOSC", "oS_WYS_MAKS", "oS_WYS_MIN", "oS_ROZPIETOSC", 
    "oS_NACHYLENIE", "oS_AZYMUT", "sG_WYSOKOSC", "sG_NACHYLENIE", "sG_SZCZELINY", "sG_SKARPY_WTORNE",
    "kO_WYS_CZOLA", "kO_DLUGOSC", "kO_NACHYLENIE", "kO_MIAZSZOSC_POM", "kO_MIAZSZOSC_SZAC", "kO_WYSOKOSC", "tyP_STOKU_SID", "sT_NACHYLENIE", "kieruneK_EKSPOZYCJI_SID", "sT_DLUGOSC", "sT_WYSOKOSC",
    "tectonics", "rocks", "koluvia", "waterManifestation1", "waterManifestation2", "waterManifestation3", "waterManifestation4",
    "developments", "landUse", "uT_ZAB_MIESZKALNA", "uT_ZAB_GOSPODARCZA", "uT_ZAB_PRZEM_USLUG", "uT_ZAB_UZYT_PUBL", "uT_ZAB_ZABYT_SAKR", "uT_ZAB_INNA",
    "roads", "szkodY_UPRAWY", "szkodY_ZABUDOWA_OPIS", "szkodY_KOMUNIKACJA_OPIS", "roadDamages", "szkodY_LINIE_PRZESYLOWE", "szkodY_INNE", 
    "zagrozeniA_UPRAWY", "zagrozeniA_ZABUDOWA", "zagrozeniA_LINIE_PRZESYLOWE", "zagrozeniA_INNE", "zagrozeniA_KOMUNIKACJA", "dalszE_RUCHY",
    "zabezpieczeniE_OPIS", "monitorinG_WSKAZ_WIZJI", "monitorinG_WSKAZ_MON", "czY_MONITORING", "czY_MONITORING_POWIERZCHNIOWY", "czY_MONITORING_WGLEBNY", "landslideMonitoringRegisters",
    "publications", "rastersElements1", "rastersElements3", "uwagi","designationCriteria", "wskazania", "elaborators", "datA_USTALENIA", "datA_WYPELNIENIA"]
}

export const HeadlineNamesKRO = () => {
    var headlineNames: Record<string, string[]> = {};
    headlineNames["Numer ewidencyjny"] = ["numeR_IDENTYFIKACYJNY", "numeR_ROBOCZY"];
    headlineNames["Lokalizacja"] = ["miejscowosC_NAZWA", "gmina", "powiat", "wojewodztwo", "numerY_DZIALEK", "sheets", "sMGP50Ks", "pL1992_X", "pL1992_Y",
        "grS80_DLUGOSC", "grS80_SZEROKOSC", "geographicalLands", "tectonicUnits", "zlewnia", "lokalizacjA_OPIS"];
    headlineNames["Charakterystyka"] = ["sytuacjA_GEOMORFOLOGICZNA_SID", "uklaD_GEOLOGICZNY_SID", "rodzaJ_MATERIALU_SID", "rodzaJ_RUCHU_SID", "stopieN_AKTYWNOSCI",
        "charakterystykA_OPIS"];
    headlineNames["Parametry morfologiczne ogólne"] = ["oS_POWIERZCHNIA", "oS_DLUGOSC", "oS_SZEROKOSC", "oS_WYS_MAKS", "oS_WYS_MIN", "oS_ROZPIETOSC", "oS_NACHYLENIE", "oS_AZYMUT"];
    headlineNames["Parametry morfologiczne skarpa główna"] = ["sG_WYSOKOSC", "sG_NACHYLENIE", "sG_SZCZELINY", "sG_SKARPY_WTORNE"];
    headlineNames["Parametry morfologiczne koluwium"] = ["kO_WYS_CZOLA", "kO_DLUGOSC", "kO_NACHYLENIE", "kO_MIAZSZOSC_POM", "kO_MIAZSZOSC_SZAC", "kO_WYSOKOSC"];
    headlineNames["Podłoże"] = ["tectonics", "rocks"];
    headlineNames["Materiał koluwialny"] = ["koluvia"];
    headlineNames["Przejawy wód powierzchniowych i gruntowych w obrębie"] = ["waterManifestation1", "waterManifestation2", "waterManifestation3", "waterManifestation4"];
    headlineNames["Wiek i geneza osuwiska"] = ["developments"];
    headlineNames["Użytkowanie terenu w obrębie osuwiska"] = ["landUse"];
    headlineNames["Zabudowa"] = ["uT_ZAB_MIESZKALNA", "uT_ZAB_GOSPODARCZA", "uT_ZAB_PRZEM_USLUG", "uT_ZAB_UZYT_PUBL", "uT_ZAB_ZABYT_SAKR", "uT_ZAB_INNA"];
    headlineNames["Infrastruktura komunikacyjna"] = ["roads"];
    headlineNames["Szkody"] = ["szkodY_UPRAWY", "szkodY_ZABUDOWA_OPIS", "szkodY_LINIE_PRZESYLOWE", "szkodY_INNE", "szkodY_KOMUNIKACJA_OPIS", "roadDamages"];
    headlineNames["Zagrożenia"] = ["zagrozeniA_UPRAWY", "zagrozeniA_ZABUDOWA", "zagrozeniA_LINIE_PRZESYLOWE", "zagrozeniA_INNE", "zagrozeniA_KOMUNIKACJA", "dalszE_RUCHY"];
    headlineNames["Rodzaje i zakres wykonywanych prac zabezpieczających"] = ["zabezpieczeniE_OPIS"];
    headlineNames["Prowadzenie obserwacji"] = ["monitorinG_WSKAZ_WIZJI", "monitorinG_WSKAZ_MON"];
    headlineNames["Monitoring"] = ["czY_MONITORING", "czY_MONITORING_POWIERZCHNIOWY", "czY_MONITORING_WGLEBNY", "landslideMonitoringRegisters"];
    headlineNames["Stok, na którym jest osuwisko"] = ["tyP_STOKU_SID", "sT_NACHYLENIE", "kieruneK_EKSPOZYCJI_SID", "sT_DLUGOSC", "sT_WYSOKOSC"];
    headlineNames["Stan badań"] = ["publications"];
    headlineNames["Mapa"] = ["rastersElements1"];
    headlineNames["Dokumentacja fotograficzna"] = ["rastersElements3"];
    headlineNames["Informacje o możliwości zabezpieczenia oraz informacje dodatkowe"] = ["uwagi"];
    headlineNames["Wypełniający kartę"] = ["elaborators"];
    headlineNames["Data ustalenia"] = ["datA_USTALENIA"];
    headlineNames["Data wypełnienia karty"] = ["datA_WYPELNIENIA"];
    return headlineNames;
}

export const HeadlineNamesKRTZ = () => {
    var headlineNames: Record<string, string[]> = {};
    headlineNames["Numer ewidencyjny"] = ["numeR_IDENTYFIKACYJNY", "numeR_ROBOCZY"];
    headlineNames["Lokalizacja"] = ["miejscowosC_NAZWA", "gmina", "powiat", "wojewodztwo", "numerY_DZIALEK", "godlo10k", "sMGP50Ks", "pL1992_X", "pL1992_Y",
        "grS80_DLUGOSC", "grS80_SZEROKOSC", "geographicalLands", "tectonicUnits", "zlewnia", "rastersElements1"];
    headlineNames["Wskazania dotyczące obserwacji"] = ["wskazania"];
    headlineNames["Data ustalenia"] = ["datA_USTALENIA"];
    headlineNames["Data wypełnienia karty"] = ["datA_WYPELNIENIA"];
    headlineNames["Główne kryteria wyznaczenia terenu"] = ["designationCriteria"];
    headlineNames["Wypełniający kartę"] = ["elaborators"];
    return headlineNames;
}

export enum NavHeadingsKROEnum {
    RegistrationNumber,
    Location,
    Characteristics,
    MorfologicalParameters,
    Subsoil,
    ColluvialMaterial,
    WaterManifestation,
    GenesisAndAge,
    LandUse,
    ThreatsAndDamage,
    WorkPerformed,
    ConductingObservation,
    ResearchState,
    MapSection,
    GeologicalCrossSection,
    PhotographicDocumentation,
    SecurityOptions,
    ElaboratorsAndInstitutions,
    DeterminationDate,
    CardCompletionDate
}

export enum NavHeadingsKRTZEum {
    RegistrationNumber,
    Location,
    MainCriterionForArea,
    ObservationInstructions,
    ElaboratorsAndInstitutions,
    DeterminationDate,
    CardCompletionDate
}

type KrFormContextType<Type> = {
    krForm: Type,
    setkrForm: (krForm: Type) => {},
    local: boolean | undefined,
    fillDate: number
    setFillDate: (fillDate: number) => { }
};

export type KrFormContextLandslideType = KrFormContextType<KrLandslideFormTypes>;
export type KrFormContextEndangeredAreaType = KrFormContextType<KrEndangeredAreaFormTypes>;

const KrFormContext = createContext({
    krForm: defaultKrForm(),
    setkrForm: (krForm: krFormTypes) => { },
    local: false,
    fillDate: 0,
    setFillDate: (fillDate: number) => { }
});

export default KrFormContext;